/**
 * Version Manager for EstateCoin
 * Handles automatic version updates and cache busting
 *
 * IMPORTANT: Increment APP_VERSION whenever you make changes to force update
 */

// Current app version - INCREMENT THIS to force update all users
export const APP_VERSION = "1.8.4"; // FIX: Login password hash restoration complete

// Version tracking in localStorage
const VERSION_KEY = "estatecoin_app_version";

/**
 * Check if app version has changed and force reload if needed
 */
export const checkVersionUpdate = () => {
  const storedVersion = localStorage.getItem(VERSION_KEY);

  if (storedVersion && storedVersion !== APP_VERSION) {
    // Clear all caches
    if ("caches" in window) {
      caches.keys().then((names) => {
        names.forEach((name) => {
          caches.delete(name);
        });
      });
    }

    // Update stored version
    localStorage.setItem(VERSION_KEY, APP_VERSION);

    // Force reload to get new version
    window.location.reload(true);
    return true;
  }

  // Store current version
  if (!storedVersion) {
    localStorage.setItem(VERSION_KEY, APP_VERSION);
  }

  return false;
};

/**
 * Initialize version checking on app load
 */
export const initVersionCheck = () => {
  // Check version immediately
  checkVersionUpdate();

  // Check version every 1 hour instead of 30 seconds to avoid frequent reloads
  setInterval(() => {
    checkVersionUpdate();
  }, 3600000); // 1 hour
};

/**
 * Force clear all caches and reload
 */
export const forceClearCacheAndReload = async () => {
  // Clear service worker caches
  if ("caches" in window) {
    const names = await caches.keys();
    await Promise.all(names.map((name) => caches.delete(name)));
  }

  // Service worker registration disabled - no unregistration needed

  // Clear localStorage version
  localStorage.removeItem(VERSION_KEY);

  // Force hard reload
  window.location.reload(true);
};

export default {
  APP_VERSION,
  checkVersionUpdate,
  initVersionCheck,
  forceClearCacheAndReload,
};
